import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/sources/$id/$mappingPath/$type/preview/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.SOURCES_MAPPING });
    context.validatePermissions({ isAllowed, preload });
  },
});
